export default __webpack_public_path__ + "static/media/desktop.4e6f6e3c.jpg";